import Dropdown from '@/components/dropdown'
import { FC } from 'react'

export interface BodyProps {
  className?: string
  children?: React.ReactNode
}

export const _Body: FC<BodyProps> = ({ children, className }) => {
  return <Dropdown.Body className={className}>{children}</Dropdown.Body>
}
